import {
  Button,
  Container,
  Drawer,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  search: {
    paddingBottom: theme.spacing(3),
    flexWrap: 'nowrap',
  },
  btnAddUser: {
    height: '48px',
    textTransform: 'capitalize',
  },
  drawer: {
    width: 472,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 472,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
  },
  close: {
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
  },
  formButton: {
    padding: theme.spacing(2),
  },
  formButtonWrapper: {
    marginTop: 'auto',
  },
  btnAdd: {
    display: 'flex',
    alignItems: 'center',
  },
  coursesChip: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  error: {
    color: 'red',
    paddingTop: '5px',
    display: 'block',
  },
  w100: {
    paddingLeft: '16px',
    '& > *': {
      width: '100%',
    },
  },
  form: {
    padding: theme.spacing(2),
    '& > *': {
      width: '100%',
      marginBottom: theme.spacing(3),
    },
  },
  bodyContainer: {
    height: '100%',
  },
  emptyMessage: {
    margin: theme.spacing(10),
    textAlign: 'center',
  },
  dFlex: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

function CustomDrawer({ open, drawerConfig, onClose, onDrawerSubmit, ...rest }) {
  const classes = useStyles();

  const handleFormSubmit = event => {
    event.preventDefault();
    onDrawerSubmit(event);
  };

  return (
    <>
      <Drawer
        className={classes.drawer}
        anchor={drawerConfig.anchor}
        open={open}
        onClose={onClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {/* Header section for drawer. Includes title and close button */}
        <div className={classes.drawerHeader}>
          <Typography variant="h4" noWrap className={classes.title}>
            {drawerConfig.title}
          </Typography>
          <IconButton onClick={onClose} className={classes.close}>
            <CloseIcon />
          </IconButton>
        </div>

        {/* Body of the drawer. Will make this re-useable as need increases. */}
        <Container>
          <form className={classes.form} onSubmit={handleFormSubmit} noValidate autoComplete="off">
            <FormControl component="fieldset" className={classes.bodyContainer}>
              {drawerConfig.legend && (
                <FormLabel component="legend" className={classes.dFlex}>
                  <InsertDriveFileOutlinedIcon />
                  {drawerConfig.legend}
                </FormLabel>
              )}

              {rest.children}
            </FormControl>

            {/* Bottom/Button section for drawer */}
            <Grid className={classes.formButtonWrapper}>
              <Button
                color="primary"
                fullWidth
                type="submit"
                variant="contained"
                className={classes.formButton}
                disabled={drawerConfig.disableButton}
              >
                {drawerConfig.buttonText}
              </Button>
            </Grid>
          </form>
        </Container>
      </Drawer>
    </>
  );
}

export { CustomDrawer };
